export const ScheduleStatus = {
    DRAFT: 'DRAFT',
    DEPARTMENT_REVIEW: 'DEPARTMENT_REVIEW',
    DEPARTMENT_APPROVED: 'DEPARTMENT_APPROVED',
    FACULTY_REVIEW: 'FACULTY_REVIEW',
    FACULTY_APPROVED: 'FACULTY_APPROVED',
    OFFICE_REVIEW: 'OFFICE_REVIEW',
    RETURNED: 'RETURNED',
    APPROVED: 'APPROVED',
    PUBLISHED: 'PUBLISHED',
    ARCHIVED: 'ARCHIVED',
};
/** Значення в порядку оголошення в схемі. */
export const SCHEDULE_STATUS_VALUES = ['DRAFT', 'DEPARTMENT_REVIEW', 'DEPARTMENT_APPROVED', 'FACULTY_REVIEW', 'FACULTY_APPROVED', 'OFFICE_REVIEW', 'RETURNED', 'APPROVED', 'PUBLISHED', 'ARCHIVED'];
export const SCHEDULE_STATUS_LABELS = {
    DRAFT: 'Чернетка',
    DEPARTMENT_REVIEW: 'На погодженні кафедри',
    DEPARTMENT_APPROVED: 'Погоджено кафедрою',
    FACULTY_REVIEW: 'На погодженні факультету',
    FACULTY_APPROVED: 'Погоджено факультетом',
    OFFICE_REVIEW: 'На перевірці навчального відділу',
    RETURNED: 'Повернуто на доопрацювання',
    APPROVED: 'Затверджено',
    PUBLISHED: 'Опубліковано',
    ARCHIVED: 'Архів',
};
export const SCHEDULE_STATUS_TONES = {
    DRAFT: 'neutral',
    DEPARTMENT_REVIEW: 'warning',
    DEPARTMENT_APPROVED: 'info',
    FACULTY_REVIEW: 'warning',
    FACULTY_APPROVED: 'info',
    OFFICE_REVIEW: 'warning',
    RETURNED: 'danger',
    APPROVED: 'success',
    PUBLISHED: 'success',
    ARCHIVED: 'neutral',
};
//# sourceMappingURL=schedule-status.js.map